/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { Store } from 'redux';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { IContext, IState } from '../../../../shared/store';
import { DynamicCalltrackingContext } from '@cian/frontend-dynamic-calltracking-component';

interface IDependencies {
  offerCardPage: JSX.Element;
  store: Store<IState>;
  context: IContext;

  cb(): void;

  rootElement: HTMLElement;
}

export function renderReactApp({ cb, store, offerCardPage, rootElement, context }: IDependencies) {
  const { httpApi, logger } = context;

  ReactDOM.render(
    //tslint:disable-next-line:no-any
    <Provider store={store as any}>
      <DynamicCalltrackingContext.Provider value={{ httpApi, logger }}>
        {offerCardPage}
      </DynamicCalltrackingContext.Provider>
    </Provider>,
    rootElement,
    cb,
  );
}
